import ActionCard from '@components/ActionCard/ActionCard.component'
import { Box, InputAdornment, Pagination, TextField, Typography } from '@mui/material'
import { styled } from '@mui/system'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import Grid from '@mui/material/Grid';
import TechStackCard from '@components/TechStackCard/TechStackCard.component';
import SearchIcon from 'icons/Search.icon';
import { Route as TechnologyRoute } from './_admin.technology.$id';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import AdminPageHeader from '@components/AdminPageHeader/AdminPageHeader.component';
import { useState } from 'react';


export const Route = createFileRoute('/(admin)/_admin/admin-dashboard')({
  component: RouteComponent,
})


const StyledSearch = styled(TextField)(() => ({
    input: {
        lineHeight: '20px',
    },
    width: '50%',
    '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid var(--Interviewer-Lightest-Black)'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        border: '1px solid var(--Interviewer-Black)',
    },
    '&:focused .MuiOutlinedInput-notchedOutline': {
        border: '1px solid var(--Interviewer-Black)',
    },
}));

function RouteComponent() {
    const navigate = useNavigate();

    const { data, isLoading, error } = useQuery({
    queryKey: ['admin-technologies'],
    queryFn: async () => {
        const token = localStorage.getItem('token');
        const response = await axios.get('https://interviewer.runasp.net/api/technologies', {
          headers: {
              Authorization: `Bearer ${token}`,
          },
        });
        return response.data;
    }
    });
  return (
    <Box>
        <AdminPageHeader title="Interviewer Dashboard" />
        <Box sx={{
          px: {
            xs: '16px',
            md: '32px'    
          },
          py: {
            xs: '16px',
            md: '32px'
          }
        }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
                gap: '20px',
                mb: '48px',
              }}
            >
              <ActionCard
                cardType="technology"
                title="Create a technology"
                description="Click here to create technology"
                onClick={() => navigate({ to: '/create-technology' })}
              />
              <ActionCard
                cardType="category"
                title="Create a category"
                description="Click here to create a category for a specific technology"
                onClick={() => navigate({ to: '/create-category' })}
              />
              <ActionCard
                cardType="interview"
                title="Create a interview"
                description="Click here to create an interview"
                onClick={() => navigate({ to: '/create-interview' })}
              />
            </Box>
            <Typography variant='h2' sx={{pb: '24px', fontSize: '24px'}}>Created Technologies</Typography>
            <StyledSearch
                sx={{width: {xs: '100%', lg: '50%'}, backgroundColor: '#fff'}}
                type="search"
                slotProps={{
                input: {
                    startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                    ),
                },
                }}
                placeholder="Search for a technology"
            />
            <Grid container spacing={'20px'} mt={'32px'}>
                {data?.map((item: any) => (
                <Grid size={{ xs: 12, lg: 6 }} key={item.id}>
                    <TechStackCard
                      id={item.id}
                      title={item.name}
                      description={item.description || ''}
                      lastUpdated={item.updatedOnUtc}
                      onClick={() =>
                          navigate({
                          to: TechnologyRoute.to,
                          params: { id: item.id },
                          })
                      }
                    />
                </Grid>
                ))}
            </Grid>
        </Box>
    </Box>
  )
}
